import React, { useState, useRef, forwardRef, useContext, useCallback } from "react";

import { isEmpty, callApi, spaceCheck, exceptKorean } from "bodycodi/cmap/app/js/common";
import { StateContext, DispatchContext } from "bodycodi/cmap/app/components/common/context";
import CustomDialog from "bodycodi/cmap/app/components/common/customDialog";
import PopupHeader from "bodycodi/cmap/app/components/common/popupHeader";
import FindPasswordWrap from "bodycodi/cmap/app/components/cmap1010/findPassword";
import errorIng from "bodycodi/cmap/app/img/error-1010.png";
import succesImg from "bodycodi/cmap/app/img/good-1010.png";
import icon_eye_on from "bodycodi/cmap/app/svg/icon_eye_on.svg";
import icon_eye_off from "bodycodi/cmap/app/svg/icon_eye_off.svg";

function ChangePasswordPop() {
  const { state } = useContext(StateContext);
  const { dispatch } = useContext(DispatchContext);

  const handleClose = () => {
    dispatch({
      type: "POP_UP_OPEN",
      id: "CHANGE_PASSWORD_POP",
      open: { changePasswordPop: false },
    });
  };

  return (
    <CustomDialog open={state.changePasswordPop} onClose={handleClose}>
      {state.changePasswordPop && <ChangePasswordWrap onClose={handleClose} />}
    </CustomDialog>
  );
}

interface ChangePasswordWrap {
  onClose: () => void;
}

function ChangePasswordWrap({ onClose }: ChangePasswordWrap) {
  const [step, setStep] = useState(1);

  return (
    <>
      {step === 1 && (
        <>
          <PopupHeader title={"비밀번호 확인"} onClickBack={onClose} />
          <OldPassWord setStep={setStep} />
        </>
      )}
      {step === 2 && (
        <>
          <PopupHeader title={"비밀번호 변경"} onClickBack={onClose} />
          <ChangePassword onClose={onClose} />
        </>
      )}
    </>
  );
}

interface OldPassWord {
  setStep: (step: number) => void;
}

function OldPassWord({ setStep }: OldPassWord) {
  const { dispatch } = useContext(DispatchContext);
  const [oldPassword, setOldPassword] = useState("");
  const [newValText, setNewValText] = useState("");

  const handleClickFindPassword = () => {
    dispatch({ type: "POP_UP_OPEN", id: "FIND_PASSWORD_POP", open: { findPasswordPop: true } });
  };

  const exceptKorean1 = (e: any) => {
    e.currentTarget.value = exceptKorean(e.currentTarget.value);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setOldPassword(e.target.value);
  };

  const handleConfirmPassword = () => {
    callApi("/cmap5050/execPwdChk", { password: oldPassword }, "POST").then((res) => {
      if (res.MsgVO.msgCd === "Cmap5050-00") {
        setStep(2);
      } else {
        setNewValText(res.MsgVO.msgCtnt);
      }
    });
  };

  return (
    <>
      <section className="popup-body change-password-pop">
        <div className="change-password-input-wrap">
          <Input
            title="기존 비밀번호"
            type="password"
            placeholder="기존 비밀번호 입력"
            onKeyUp={exceptKorean1}
            errorText={newValText}
            value={oldPassword}
            onChange={handleChange}
          />
          <div className="lost-password" onClick={handleClickFindPassword}>
            비밀번호가 기억나지 않나요?
          </div>
        </div>
        <div
          className={"change-password-btn" + (oldPassword ? " active" : "")}
          onClick={handleConfirmPassword}
        >
          비밀번호 확인
        </div>
      </section>
      <FindPasswordWrap />
    </>
  );
}

function ChangePassword({ onClose }: ChangePasswordWrap) {
  const { dispatch } = useContext(DispatchContext);
  const newPassword = useRef<HTMLInputElement>(null);
  const newPasswordConfirm = useRef<HTMLInputElement>(null);
  const [newValText, setNewValText] = useState("");
  const [newValTextConfirm, setNewValTextConfirm] = useState("");
  const [succesText, setSuccesText] = useState("");
  const [passwordCrtf, setPasswordCrtf] = useState(false);

  const checkMixEngNum = (password: string) => {
    const num = password.search(/[0-9]/g);
    const eng = password.search(/[a-z]/gi);
    return num >= 0 && eng >= 0;
  };

  const exceptKorean1 = (e: any) => {
    e.currentTarget.value = exceptKorean(e.currentTarget.value);
  };

  const checkPassword = () => {
    const newVal = newPassword.current!.value;

    setSuccesText("");
    if (isEmpty(newVal)) {
      setNewValText("새 비밀번호를 입력해 주세요.");
      setNewValTextConfirm("");
      setPasswordCrtf(false);
      return false;
    } else if (spaceCheck(newVal)) {
      setNewValText("새 비밀번호 앞뒤에 공백이 들어갈수 없습니다.");
      setNewValTextConfirm("");
      setPasswordCrtf(false);
      return false;
    } else if (!checkMixEngNum(newVal) || newVal.length < 8) {
      setNewValText("영문, 숫자 포함 8글자 이상 입력해주세요.");
      setNewValTextConfirm("");
      setPasswordCrtf(false);
      return false;
    } else {
      callApi("/cmap5050/execNewPwdChk", { password: newVal }, "POST").then((res) => {
        if (res.MsgVO.msgCd !== "Cmap5050-00") {
          setNewValText(res.MsgVO.msgCtnt);
          setNewValTextConfirm("");
          setPasswordCrtf(false);
          return false;
        } else {
          setNewValText("");
          return true;
        }
      });
    }
  };

  const checkPasswordConfirm = () => {
    const newVal = newPassword.current!.value;
    const newValConfirm = newPasswordConfirm.current!.value;

    setSuccesText("");
    if (!isEmpty(newValText)) {
      setNewValTextConfirm("");
      return false;
    } else if (isEmpty(newValConfirm)) {
      setNewValTextConfirm("새 비밀번호 확인을 입력해 주세요.");
      setPasswordCrtf(false);
      return false;
    } else if (newVal !== newValConfirm) {
      setNewValTextConfirm("새 비밀번호와 동일하지 않습니다.");
      setPasswordCrtf(false);
      return false;
    } else {
      setNewValTextConfirm("");
      setSuccesText("새로운 비밀번호와 일치합니다.");
      setPasswordCrtf(true);
      return true;
    }
  };

  const clickConfirm = useCallback(() => {
    if (passwordCrtf) {
      const newVal = newPassword.current!.value;
      if (isEmpty(newVal)) {
        return false;
      }
      callApi("/cmap5050/execPwdUpd", { password: newVal }, "POST").then((res) => {
        const msgVO = res.MsgVO;
        if (msgVO.msgCd === "Cmap5050-00") {
          onClose();
        }
      });
    } else {
      const newVal = newPassword.current!.value;
      const newValConfirm = newPasswordConfirm.current!.value;
      if (isEmpty(newVal)) {
        openAlert("새 비밀번호를 입력해 주세요.");
      } else if (spaceCheck(newVal)) {
        openAlert("새 비밀번호 앞뒤에 공백이 들어갈수 없습니다.");
      } else if (!checkMixEngNum(newVal) || newVal.length < 8) {
        openAlert("영문, 숫자 포함 8글자 이상 입력해주세요.");
      } else if (isEmpty(newValConfirm)) {
        openAlert("새 비밀번호 확인를 입력해 주세요.");
      } else if (newVal != newValConfirm) {
        openAlert("새 비밀번호와 같지 않습니다.");
      }
    }
  }, [passwordCrtf]);

  const openAlert = useCallback((body) => {
    dispatch({
      type: "UPDATE",
      data: {
        alert: true,
        alertFunc: () => ({}),
        alertBody: body,
        alertHeader: "비밀번호 변경",
        alertBtnText: "",
      },
    });
  }, []);

  return (
    <section className="popup-body change-password-pop">
      <Input
        title="새 비밀번호"
        type="password"
        placeholder="영문, 숫자 포함 8글자이상"
        onKeyUp={exceptKorean1}
        onBlur={checkPassword}
        ref={newPassword}
        errorText={newValText}
      />
      <Input
        title="새 비밀번호 확인"
        type="password"
        placeholder="영문, 숫자 포함 8글자이상"
        onKeyUp={exceptKorean1}
        onBlur={checkPasswordConfirm}
        ref={newPasswordConfirm}
        errorText={newValTextConfirm}
        succesText={succesText}
      />
      <div
        className={"change-password-btn" + (passwordCrtf ? " active" : "")}
        color="#fff"
        onClick={clickConfirm}
      >
        비밀번호 변경
      </div>
    </section>
  );
}

type Input = {
  type: string;
  name?: string;
  placeholder: string;
  title: string;
  onClick?: any;
  onBlur?: any;
  onKeyUp?: any;
  errorText?: string;
  succesText?: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

export const Input = forwardRef(
  (
    {
      type,
      name = "",
      placeholder,
      title,
      onClick,
      onBlur,
      onKeyUp,
      errorText,
      succesText,
      value,
      onChange,
    }: Input,
    ref: any
  ) => {
    const [hidden, setHidden] = useState(true);

    const clickEye = () => {
      setHidden(!hidden);
    };

    return (
      <div className={"cmap1010-input" + (!isEmpty(errorText) ? " error" : "")}>
        <div className="title">{title}</div>
        <div
          className={
            "input-wrap" +
            (!isEmpty(errorText) ? " error" : "") +
            (!isEmpty(succesText) ? " succes" : "")
          }
        >
          <div className="input">
            <input
              type={hidden ? type : "text"}
              name={name}
              placeholder={placeholder}
              {...(!isEmpty(onClick) && { onClick: onClick })}
              {...(!isEmpty(onBlur) && { onBlur: onBlur })}
              {...(!isEmpty(onKeyUp) && { onKeyUp: onKeyUp })}
              {...(!isEmpty(onChange) && { onChange: onChange })}
              ref={ref}
              value={value}
            />
            {hidden && <img src={icon_eye_off} onClick={clickEye} />}
            {!hidden && <img src={icon_eye_on} onClick={clickEye} />}
          </div>
        </div>
        <div className={"error-wrap" + (!isEmpty(errorText) ? " active" : "")}>
          <div className="error">
            <img src={errorIng} />
            <span>{errorText}</span>
          </div>
        </div>
        <div className={"succes-wrap" + (!isEmpty(succesText) ? " active" : "")}>
          <div className="succes">
            <img src={succesImg} />
            <span>{succesText}</span>
          </div>
        </div>
      </div>
    );
  }
);
Input.displayName = "Input";

export default ChangePasswordPop;
